/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useEffect, useState } from 'react'
import GradientButton from '../MUICustomButton/GradientButton'
import CustomDataTable from '../CustomDataTable/CustomDataTable'
import type { TableColumn } from 'react-data-table-component';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { deactivateRole, deleteRole, getAllRoles } from 'src/services/roleService';
import MUIModal from '../MUIModal/MUIModal';
import AddNewRole from './AddnewRole';
// @ts-ignore
import { NotificationManager } from 'react-notifications';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { UPDATE_ROLE_ACTIVATE_ROLE_SUCCESS_MESSAGE, UPDATE_ROLE_ACTIVE_DEACTIVATE_SUBTITLE_1, UPDATE_ROLE_DEACTIVATE_ROLE_SUCCESS_MESSAGE, UPDATE_ROLE_DELETE_ROLE_SUCCESS_MESSAGE, UPDATE_ROLE_DELETE_SUBTITLE_2, UPDATE_USER_DELETE_SUBTITLE_1 } from 'src/constants/constant';
import UpdateRole from './UpdateRole';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface IRolesData {
  roleId?: number | null;
  roleName: string;
  description: string;
  isDeleted: boolean;
  isActive: boolean;
  createdBy: string;
}

interface ApiResponse {
  status: number;
  data: {
    data: IRolesData[];
    result: number;
  };
}

const ITEM_HEIGHT = 48;

const RoleList: React.FC = () => {

  const [roleListArray, setRoleListarray] = useState<IRolesData[]>([])
  const [roleSearchData, setRoleSearchData] = useState<IRolesData[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [addNewRoleModal, setAddNewRoleModal] = useState<boolean>(false);
  const [anchorActionEl, setAnchorActionEl] = useState<any>({});
  const [showDeleteRoleModal, setDeleteRoleModal] = useState<boolean>(false);
  const [roleInfoData, setRoleInfoData] = useState<any>();
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [showDeactivateRoleModal, setDeactivateRoleModal] = useState<boolean>(false);
  const [selectedRoleInfo, setSelectedRoleInfo] = useState<any>(null);
  const [openUpdateRoleModal, setOpenUpdateRoleModal] = useState<boolean>(false)


  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: any): void => {
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  useEffect(() => {
    getRoleData()
  }, [])

  const getRoleData = (): void => {
    setLoading(true)
    getAllRoles()
      .then(
        (res: ApiResponse) => {
          console.log("Roles", res)
          if (res.status === 200) {
            if (res.data.result === 1) {
              setRoleListarray(res.data.data)
              setRoleSearchData(res.data.data)
            }
          }
        }
      )
      .catch(
        error => console.log("Error", error)
      )
      .finally(
        () => setLoading(false)
      )
  }

  const handleAddRoleClick = (): void => {
    setAddNewRoleModal(true)
  }

  const handleCloseAddRoleModal = (): void => {
    setAddNewRoleModal(false)
  }

  const handleRefreshPage = (): void => {
    setAddNewRoleModal(false)
    setOpenUpdateRoleModal(false);
    getRoleData()
  }

  const handleDeleteRole = (roleId: string, roleName: string): void => {
    setRoleInfoData({ roleId, roleName });
    setDeleteRoleModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [roleId]: null });
  }

  const handleDeleteRoleClose = ():void => {
    setDeleteRoleModal(false)
  }

  const handleDeleteRoleConfirm = ():void => {
    setIsModalSaveLoading(true)

    const { roleId } = roleInfoData;
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    

    deleteRole(roleId, userData.id)
      .then(
        (res: ApiResponse) => {
          if(res.status === 200) {
            if(res.data.result === 1) {
              NotificationManager.success(UPDATE_ROLE_DELETE_ROLE_SUCCESS_MESSAGE, '', 5000);
              setDeleteRoleModal(false)
              getRoleData()
            }
          }
        }
      )
      .catch(error => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleDeactivateRole = (roleId: string, isActive: boolean, roleName: string): void => {
    const newIsActive = !isActive;
    setRoleInfoData({ roleId, isActive: newIsActive, roleName });
    setDeactivateRoleModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [roleId]: null });
  }

  const handleDeactivateRoleClose = ():void => {
    setDeactivateRoleModal(false)
  }

  const handleDeactivateRoleConfirm = ():void => {
    setIsModalSaveLoading(true)

    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { roleId, isActive } = roleInfoData;
    

    deactivateRole(roleId, isActive, userData.id)
      .then(
        (res: ApiResponse) => {
          if(res.status === 200) {
            if(res.data.result === 1) {
              if (isActive) {
                NotificationManager.success(UPDATE_ROLE_ACTIVATE_ROLE_SUCCESS_MESSAGE, '', 5000);
              } else {
                NotificationManager.success(UPDATE_ROLE_DEACTIVATE_ROLE_SUCCESS_MESSAGE, '', 5000);
              }
              setDeactivateRoleModal(false)
              getRoleData()
            }
          }
        }
      )
      .catch(error => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const handleUpdateRole = (roleId: string, roleName: string, description: string): void => {
    setSelectedRoleInfo({ roleId, roleName, description });
    setOpenUpdateRoleModal(true);
    // Store roleId in session storage
    sessionStorage.setItem('roleId', roleId);
  };

  const handleCloseUpdateRoleModal = (): void => {
    setOpenUpdateRoleModal(false);
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let roleDataArr = roleListArray
    if (value !== "") {
      roleDataArr = roleSearchData.filter((role: IRolesData) => {
        return role.roleName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setRoleSearchData(roleDataArr)
  }

  const columns: TableColumn<IRolesData>[] = [
    {
      name: 'Role Name',
      selector: (row: IRolesData) => row.roleName,
      cell: (row: IRolesData) => {
        return (
          <div className='flex py-4 first:pt-0 last:pb-0'>
            <div className="overflow-hidden">
              <p className="text-14 text-muted">{row.roleName}</p>
            </div>
          </div>
        )
      },
      width: '25%',
      sortable: true
    },
    {
      name: 'Description',
      sortable: true,
      // selector: row => row.year,
      width: '30%',
      cell: (row: IRolesData) => <span>{row.description}</span>
    },
    {
      name: 'Status',
      sortable: true,
      width: "25%",
      // selector: row => row.year,
      cell: (row: IRolesData) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : (
          <div className="badge truncate" style={{
            background: '#FFF5F6',
            padding: '10px 15px',
            color: '#F13139',
            border: '0px'
          }}>Inactive</div>
        );
      }
    },
    {
      name: 'Actions',
      sortable: false,
      width: "15%",
      id: 'actions',
      style: {
        display: 'flex',
        justifyContent: 'flex-end'
      },
      // selector: row => row.year,
      cell: (row: IRolesData) => {
        return (
          <div className='flex'>
            {/* @ts-ignore */}
            <button className="btn btn-circle btn-outline border-0" onClick={() => handleUpdateRole(row.roleId, row.roleName, row.description)}>
              <img src={'/assets/images/icons/EditIcon.svg'} alt="" />
            </button>
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                // aria-controls={open ? 'long-menu' : undefined}
                // aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.roleId)}
              >
                <MoreVertIcon sx={{ color: "#77869E" }} />
              </IconButton>
              <Menu
                id="long-menu"
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                //@ts-ignore
                anchorEl={anchorActionEl[row.roleId]}
                //@ts-ignore
                open={Boolean(anchorActionEl[row.roleId])}
                //@ts-ignore
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.roleId]: null })}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}
              >
                {/* @ts-ignore */}
                <MenuItem onClick={() => handleDeactivateRole(row.roleId, row.isActive, row.roleName)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 19 19" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.5 0C4.26134 0 6.78571e-07 4.26134 0 9.5C6.78571e-07 14.7387 4.26134 19 9.5 19C14.7387 19 19 14.7387 19 9.5C19 4.26134 14.7387 0 9.5 0ZM9.5 1.35714C14.0052 1.35714 17.6429 4.99479 17.6429 9.5C17.6429 14.0052 14.0052 17.6429 9.5 17.6429C4.99479 17.6429 1.35714 14.0052 1.35714 9.5C1.35714 4.99479 4.99479 1.35714 9.5 1.35714Z" fill="#77869E" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M2.78219 2.78334C2.65497 2.9106 2.5835 3.08317 2.5835 3.26311C2.5835 3.44306 2.65497 3.61563 2.78219 3.74289L15.2576 16.2183C15.3206 16.2815 15.3955 16.3316 15.4779 16.3658C15.5604 16.4 15.6487 16.4176 15.738 16.4176C15.8273 16.4176 15.9156 16.4 15.9981 16.3658C16.0805 16.3316 16.1554 16.2815 16.2184 16.2183C16.3457 16.091 16.4171 15.9184 16.4171 15.7385C16.4171 15.5585 16.3457 15.386 16.2184 15.2587L3.74306 2.78334C3.68003 2.72015 3.60514 2.67001 3.5227 2.6358C3.44026 2.60159 3.35188 2.58398 3.26263 2.58398C3.17337 2.58398 3.08499 2.60159 3.00255 2.6358C2.92011 2.67001 2.84523 2.72015 2.78219 2.78334Z" fill="#77869E" />
                  </svg> <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive ? "Deactivate" : "Activate"}</span>
                </MenuItem>
                {/* @ts-ignore */}
                <MenuItem onClick={() => handleDeleteRole(row.roleId, row.roleName)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 18 19" fill="none">
                    <path d="M16.4138 4.40814C13.5622 4.12555 10.6935 3.97998 7.83344 3.97998C6.13792 3.97998 4.44241 4.06561 2.74689 4.23688L1 4.40814" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M5.70996 3.54327L5.89835 2.42149C6.03536 1.60799 6.13812 1 7.5853 1H9.82886C11.276 1 11.3874 1.64224 11.5158 2.43006L11.7042 3.54327" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14.5724 7.11426L14.0158 15.7374C13.9216 17.0818 13.8445 18.1265 11.4554 18.1265H5.95783C3.56869 18.1265 3.49162 17.0818 3.39743 15.7374L2.84082 7.11426" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.27686 13.4165H10.1284" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.56592 9.99121H10.8475" stroke="#F13139" strokeWidth="1.28448" strokeLinecap="round" strokeLinejoin="round" />
                  </svg> <span style={{ paddingLeft: '15px', color: '#F13139' }} className='font-normal'>Delete role</span>
                </MenuItem>
              </Menu>
            </div>
          </div>
        )
      }
    },
  ];

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage Roles</h2>
      <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search by role" className="input input-bordered w-auto search-input-white focus:ring-0 focus:outline-none focus:border-primary font-normal text-14 text-muted" onChange={handleSearch}/>
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">

          <GradientButton color='red' onClick={handleAddRoleClick}>
            <span style={{
              width: "20px",
              height: "20px",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50px",
              marginRight: "5px"
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
              </svg>
            </span>
            Add New Role
          </GradientButton>
        </div>
      </div>
      <div className='data-table-container mb-10 role-list-table'>
        <CustomDataTable
          columns={columns}
          data={roleSearchData}
          progressPending={loading}
          pagination
          selectableRows
        />
      </div>

      <BootstrapDialog
        onClose={handleDeleteRoleClose}
        aria-labelledby="customized-dialog-title"
        open={showDeleteRoleModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          Delete Role
        </DialogTitle>
        {/* @ts-ignore */}
        <IconButton
          aria-label="close"
          onClick={handleDeleteRoleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{UPDATE_USER_DELETE_SUBTITLE_1} <span className='font-semibold'>{roleInfoData?.roleName}</span> {UPDATE_ROLE_DELETE_SUBTITLE_2}</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleDeleteRoleClose} width='100px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleDeleteRoleConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleDeactivateRoleClose}
        aria-labelledby="customized-dialog-title"
        open={showDeactivateRoleModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          {roleInfoData?.isActive ? "Activate Role" : "Deactivate Role"}
        </DialogTitle>
        {/* @ts-ignore */}
        <IconButton
          aria-label="close"
          onClick={handleDeactivateRoleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{UPDATE_ROLE_ACTIVE_DEACTIVATE_SUBTITLE_1} {roleInfoData?.isActive ? "activate" : "deactivate"} <span className='font-semibold'>{roleInfoData?.roleName}</span> {UPDATE_ROLE_DELETE_SUBTITLE_2}</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleDeactivateRoleClose} width='130px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleDeactivateRoleConfirm} width='130px'>{!isModalSaveLoading ? roleInfoData?.isActive ? "Activate" : "Deactivate" : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <MUIModal title='Add Role' openModal={addNewRoleModal} closeModal={handleCloseAddRoleModal} width={'50%'}>
        <AddNewRole refreshPage={handleRefreshPage} closeModal={handleCloseAddRoleModal} />
      </MUIModal>

      <MUIModal title='Edit Role' openModal={openUpdateRoleModal} closeModal={handleCloseUpdateRoleModal} width={'50%'}>
        <UpdateRole selectedRoleInfo={selectedRoleInfo} closeModal={handleCloseUpdateRoleModal} refreshPage={handleRefreshPage}/>
      </MUIModal>
    </>
  )
}

export default RoleList